export default __webpack_public_path__ + "static/media/scan-claim-favicon.fc17d79e.png";